import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";

const store = {
  namespaced: true,
  state: {
    grup: null,
    grup_id: null,
    grouping: null,
    kandidat: null,
    grup_aktif: null
  },
  getters: {
    grup_aktif(state) {
      return state.grup_aktif;
    },
    grup(state) {
      return state.grup;
    },
    grup_id(state) {
      return state.grup_id;
    },
    grouping(state) {
      return state.grouping;
    },
    kandidat(state) {
      return state.kandidat;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/grupkelas${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKandidat({ state }, { instansi_id, diklat_id, grup_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/grupkelas/${grup_id}/kandidat${normParam(params)}`)
        .then(res => {
          state.kandidat = res.data;
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detil({}, { instansi_id, diklat_id, grup_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/grupkelas/${grup_id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    switchGrup({ state, dispatch }, { instansi_id, diklat_id, grup_id }) {
      // cek apakah perlu load ulang instansi
      if (state.grup_id == grup_id) {
        return state.grup_aktif;
      } else {
        return dispatch("detil", { instansi_id, diklat_id, grup_id }).then(res => {
          // reject jika instansi tidak ditemukan
          if (res.id) {
            state.grup_aktif = res;
            state.grup_id = res.id;
          } else {
            return Promise.reject();
          }
        });
      }
    },
    // eslint-disable-next-line
    form(_, { instansi_id, diklat_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/grupkelas/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/grupkelas`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios
        .delete(`${API}/api/instansi/${item.instansi_id}/diklat/${item.diklat_id}/grupkelas/${item.id}`)
        .then(res => {
          return res.data;
        });
    },
    // eslint-disable-next-line
    addInstruktur(_, { instansi_id, diklat_id, grup_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/grupkelas/${grup_id}/setjadwal`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    dropInstruktur(_, { instansi_id, diklat_id, grup_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/grupkelas/${grup_id}/unsetjadwal`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    }
  }
};

export default store;
